// Editing a typed search's filters (from:@x in:#y after:... has:file), so
// the search page's chips and what people type stay one and the same.

function split(q: string): string[] {
  return q.match(/"[^"]*"?|\S+/g) ?? [];
}

// getFilter is the value of key: in q, or "" when there is none.
export function getFilter(q: string, key: string): string {
  const t = split(q).find((t) => t.toLowerCase().startsWith(key + ":"));
  return t ? t.slice(key.length + 1) : "";
}

// setFilter puts key:value in q in place of any key: there, or with an
// empty value takes it out.
export function setFilter(q: string, key: string, value: string): string {
  const rest = split(q).filter((t) => !t.toLowerCase().startsWith(key + ":"));
  return [...rest, ...(value ? [`${key}:${value}`] : [])].join(" ");
}

// hasFlag and setFlag handle the yes-or-no filters: has:file, has:link, is:thread, is:saved.
export function hasFlag(q: string, flag: string): boolean {
  return split(q).some((t) => t.toLowerCase() === flag);
}

export function setFlag(q: string, flag: string, on: boolean): string {
  const rest = split(q).filter((t) => t.toLowerCase() !== flag);
  return [...rest, ...(on ? [flag] : [])].join(" ");
}

// isoDay writes a local date as the filters read it.
export function isoDay(d: Date): string {
  const p = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

// The date chip's choices, each a filter and its value.
export function dateChoice(choice: string, now = new Date()): [string, string] | null {
  const daysAgo = (n: number) => isoDay(new Date(now.getFullYear(), now.getMonth(), now.getDate() - n));
  switch (choice) {
    case "today":
      return ["on", "today"];
    case "yesterday":
      return ["on", "yesterday"];
    case "week":
      return ["after", daysAgo(7)];
    case "month":
      return ["after", daysAgo(30)];
  }
  return null;
}

// dateChosen reads the date chip back from q.
export function dateChosen(q: string, now = new Date()): string {
  const on = getFilter(q, "on");
  if (on === "today" || on === "yesterday") return on;
  const after = getFilter(q, "after");
  for (const c of ["week", "month"]) if (after && after === dateChoice(c, now)?.[1]) return c;
  return on || after || getFilter(q, "before") ? "custom" : "";
}
